import React from 'react';
import PropTypes from 'prop-types';

import { injectIntl, useIntl, defineMessages } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import MultiSelect, { addItem, removeItem, splitItems } from './MultiSelect';

const messages = defineMessages({
  Yes: 'Yes',
  No: 'No',
});

const YesNoSelect = ({ selection, onChange, intl, placeholder }) => {
  const items = [
    {
      id: true,
      label: intl.formatMessage(messages.Yes),
    },
    {
      id: false,
      label: intl.formatMessage(messages.No),
    },
  ];

  const [selectedItems, selectableItems] = splitItems(items, selection);

  return (
    <MultiSelect
      selectedItem={selectedItems}
      onItemRemoved={item => onChange(removeItem(selection, item))}
      onItemSelected={item => onChange(addItem(selection, item))}
      items={selectableItems}
      placeholder={placeholder}
    />
  );
};
YesNoSelect.propTypes = {
  selection: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  intl: intlShape.isRequired,
};

YesNoSelect.defaultProps = {
  selection: [],
  placeholder: null,
};

export default injectIntl(YesNoSelect);
